import React, { useState, useEffect, useMemo } from "react";
import house from "../../PicesForPages/house.png";
import calendar from "../../PicesForPages/calendar-5.png";
import smartphoneHand from "../../PicesForPages/smartphone-7.png";
import smartphoneVoice from "../../PicesForPages/smartphone-6.png";
import officeWorkLaptop from "../../PicesForPages/loan-office-work-table.jpg";
import loseIcon from "../../PicesForPages/lose.png";
import coinHand from "../../PicesForPages/coinHand.png";
import piggyBank from "../../PicesForPages/piggy-bank.png";
import houseMoney from "../../PicesForPages/houseMoney.png";
import rollerStick from "../../PicesForPages/066-roller.png";
import CreditCard from "../../PicesForPages/cc.png";
import time2 from "../../PicesForPages/time2.png";
import payMoney from "../../PicesForPages/pay.png";
import thumbsUp from "../../PicesForPages/thumbsUp.png";
import news from "../../PicesForPages/news.jpg";
import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
// import calcSmall from '../../PicesForPages/calc-small.jpg';
import ChatBotPurchase from "../Form/ChatBotPurchase";
import ChatBotRefinance from "../Form//ChatBotRefinance";
import HomePageMonthlyPayment from "../CalculatorAndChart/homePageMonthlyPayment";
import YourTeamMembers from "../StaffDetails/teamMembers";
import ClientReview from "../Client_Review/clientReview";
import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";

import { Link } from "react-router-dom";

function Home() {
  const texts = useMemo(
    () => [
      // "Lower Your Payment",
      // "Lower Your Rate",
      // "Get Your First Home",
      // "Get Your Dream Home",
      // "Get Cash Out",
      "Let’s Partner Up to Secure Your Ideal Home Loan.",
      "Together, We’ll Find the Best Mortgage Solution for You.",
      "Let’s Join Forces to Make Your Homeownership Dream a Reality.",
      "Together, We’ll Achieve the Best Rate and Terms for Your Home Loan.",
      "Let’s Collaborate to Unlock the Perfect Mortgage for You.",
      "Working Hand in Hand to Reach Your Home Financing Goals.",
      "Let’s Team Up to Secure the Best Deal for Your Future Home.",
      "Together, We’ll Navigate the Path to Your Dream Home Loan.",
    ],
    [],
  );

  const [currentText, setCurrentText] = useState("");
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [activeChatBot, setActiveChatBot] = useState(null); // null, "purchase", or "refinance"
  const typingSpeed = 100;
  const deletingSpeed = 50;

  useEffect(() => {
    const handleTyping = () => {
      const fullText = texts[currentTextIndex];

      if (!isDeleting) {
        setCurrentText((prev) => fullText.substring(0, prev.length + 1));
        if (currentText === fullText) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        setCurrentText((prev) => fullText.substring(0, prev.length - 1));
        if (currentText === "") {
          setIsDeleting(false);
          setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        }
      }
    };

    const typingInterval = setInterval(
      handleTyping,
      isDeleting ? deletingSpeed : typingSpeed,
    );

    return () => clearInterval(typingInterval);
  }, [currentText, isDeleting, texts, currentTextIndex]);

  return (
    <div className="homeParent">
      <div className="homePageFirstImage"></div>
      <div className="homeHelpYouBoxParent">
        <div className="homeHelpYouBox">
          {activeChatBot === null && (
            <>
              <span className="homeHelpYouHeading">
                <span className="homeHelpYouHeadingLeft">
                  Let's Help You...{" "}
                </span>
                <span className="typingText homeHelpYouHeadingRight">
                  {currentText}
                </span>
              </span>
              <span className="homeHelpYouContent">
                Your Dream Home, Your Best Deal – Prime Home Mortgage Makes It
                Happen!
                {/* <br /> Click our prequalifier to get started! */}
              </span>
              <span className="homeHelpYouButton">
                <button
                  className="homeHelpYouButtonLeft"
                  onClick={() => setActiveChatBot("purchase")}
                >
                  Purchase
                </button>
                <button
                  className="homeHelpYouButtonRight"
                  onClick={() => setActiveChatBot("refinance")}
                >
                  Refinance
                </button>
                <Link
                  to="/what-will-my-monthly-payment-be-calculator"
                  className="homeHelpYouButtonMP_Link"
                >
                  Monthly Payment
                </Link>
              </span>
            </>
          )}

          {/* Conditional Rendering for ChatBotPurchase */}
          {activeChatBot === "purchase" && (
            <span className="homeHelpYouChatBot">
              <ChatBotPurchase />
            </span>
          )}

          {/* Conditional Rendering for ChatBotRefinance */}
          {activeChatBot === "refinance" && (
            <span className="homeHelpYouChatBot">
              <ChatBotRefinance />
            </span>
          )}
        </div>
      </div>
      <div className="welcomeBoxParent">
        <div className="welcomeBox">
          <span className="welcomeHeading">
            Welcome To Prime Home Mortgage, INC
          </span>
          {/* <span className='welcomeContent'>At Prime Home Mortgage, INC, we treat each customer as an individual, not a number. We don't place you into a loan profile formula created by the banking industry. We use "common sense" and will help you obtain the best loan possible. We represent a wide range of "A" rated lenders with first quality rates to private "hardship" lenders.</span>
                    <span className='welcomeContent'>We work with more than 100 investors. This allows us to get you the best rates on all types of loan programs including: 30yr mortgage, 20yr mortgage, 15yr mortgage, 10yr mortgage, 1yr ARMS, 3yr ARMS, 5yr ARMS, Conventional, Jumbo, Home Equity Lines, VA and Commercial. Whether your situation calls for Full Documents, No Documents, Non-Owner Occupied (Investor) or Multi-Family, we'll fit your needs!</span> */}
          <span className="welcomeContent">
            <span>
              At Prime Home Mortgage, we believe in putting you first. Our
              mission is simple: to provide you with the best mortgage options
              tailored to your unique needs. Whether you're buying your first
              home, refinancing, or seeking other home loan solutions, our team
              is committed to offering you the best rates and clear,
              honest guidance.
            </span>
            <span>
              With access to over 100 investors, we offer the best rates on a
              variety of loan programs, including 30yr, 20yr, 15yr, 10yr
              mortgages, ARMs, Buydown, Conventional, Jumbo, VA, Commercial
              loans, and Home Equity Lines. Whether you need Full Docs, No Docs,
              Non-Owner Occupied, or Multi-Family financing, we've
              got you covered!
            </span>

            {/* <br /><br />
                        At Prime Home Mortgage Incorporated, we truly understand that buying or refinancing a home is a life-changing experience. That’s why we offer a wide variety of home loan options, designed to fit your unique needs and financial situation. We take the time to carefully compare top lenders, ensuring we find the best match for your goals, whether you're purchasing your first home or refinancing your current one. Our team is dedicated to supporting you every step of the way, providing expert guidance and personalized care to make the process as simple, stress-free, and rewarding as possible. Your dreams are our priority, and we’re here to help you make them a reality.
                        <br /><br />
                        At Prime Home Mortgage, we prioritize your needs by offering a wide range of affordable, flexible home loan options. Whether you're buying your first home or refinancing, our dedicated team is here to provide clear, honest guidance and the best rates. We carefully compare top lenders to find the perfect fit for your unique situation, ensuring a smooth, stress-free experience. Your dreams are important to us, and we’re committed to helping you achieve them with ease and confidence. Let us make your home financing journey simple and worry-free. */}
          </span>
        </div>
      </div>
      <ClientReview />

      <BlogPostInAPage />

      <div className="purchasingBoxParent">
        <div className="purchasingBox">
          <span className="purchasingHeading">Purchasing</span>
          <span className="purchasingContent">
            We deal with real estate loans, offering both conforming and
            non-conforming options.
          </span>
          <Link to="/purchase" className="purchasingButton">
            More details
          </Link>
        </div>
      </div>

      <MortgageCalculator />

      <div className="advantageBoxParent">
        <div className="advantageBox">
          <div className="advantageHeading">
            The Prime Home Mortgage, INC Advantage
          </div>
          <div className="advantageContentBoxParent">
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={house}
                  alt="house"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Community Expertise
              </span>
              <span className="advantageContentBoxContent">
                We are experts in the local area and market, and we’re part of
                your community—not just an automated service online.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={calendar}
                  alt="calender"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Speedy Processing
              </span>
              <span className="advantageContentBoxContent">
                We aim to close your loan as swiftly as possible, and we can
                handle unexpected challenges along the way!
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneHand}
                  alt="smartphoneHand"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Exceptional Service
              </span>
              <span className="advantageContentBoxContent">
                With cutting-edge technology for secure mobile uploads, we offer
                top-tier service, while also being available to assist in more
                traditional ways if needed.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneVoice}
                  alt="smartphoneVoice"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Leveraging Technology
              </span>
              <span className="advantageContentBoxContent">
                We provide state-of-the-art online tools like secure mobile
                uploading, but we're also happy to assist through more
                conventional means.
              </span>
            </span>
          </div>
        </div>
      </div>

      <YourTeamMembers />

      <div className="addressBoxParent">
        <div className="addressBox">
          <div className="addressHeading">
            The Address of Prime Home Mortgage, INC
          </div>
          <div className="addressMapDetails">
            {/* <iframe
              title="PrimeHome Mortgage, INC Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3255.399256645242!2d-80.77742482422828!3d35.32090577270577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88541dc848bbd15b%3A0x2b6ff7553848568!2s1914%20J%20N%20Pease%20Pl%2C%20Charlotte%2C%20NC%2028262%2C%20USA!5e0!3m2!1sen!2sin!4v1732532106241!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe> */}
            <iframe
              title="Prime Home Mortgage, INC Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3262.4770319747704!2d-80.73613332510303!3d35.14472205926093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88542142a401b723%3A0x21cdbdb0d8c9e57f!2s2120%20Crown%20Centre%20Dr%20%23400a%2C%20Charlotte%2C%20NC%2028227%2C%20USA!5e0!3m2!1sen!2sin!4v1737014268233!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <span className="addressDetails">
              <span className="addressDetailsTop">
                <span className="addressDetailsTopHeading">Contact Us:</span>
                <span>Email: contact@primehomemtg.com</span>
                <span>Phone: 833-745-6684</span>
                {/* <span>Address: <br />1914 JN PEASE PL
                                    <br />CHARLOTTE, NC <br />28262</span> */}
                <span>
                  Address: <br />
                  2120 Crown Centre Dr,
                  <br />
                  Suite 400A, Charlotte, NC <br />
                  28227
                </span>
              </span>
              <span className="addressDetailsBottom">
                <span className="addressDetailsBottomHeading">
                  Office Hours:
                </span>
                <span>Monday-Friday: 9am to 6pm</span>
                <span>Saturday: 10am to 2pm</span>
                <span>Sunday: Closed</span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="refinanceBoxParent">
        <div className="refinanceBox">
          <div className="refinanceContentBox">
            <span className="refinanceContentBoxHeading">Refinance</span>
            <span className="refinanceContentBoxContent">
              Refinancing a property means replacing your existing mortgage with
              a new one, usually with better terms. This can involve getting a
              lower interest rate, reducing your monthly payments, shortening
              the loan term, or switching from an adjustable-rate mortgage to a
              fixed-rate mortgage.
              <br />
              <br />
              Lower interest rates: To take advantage of lower interest rates
              and reduce monthly mortgage payments.
              <br />
              Shorten the loan term: To pay off the mortgage faster by switching
              to a shorter loan term.
              <br />
              Switch loan types: To change from an adjustable-rate mortgage to a
              fixed-rate mortgage for more stability.
              <br />
              Access home equity: To tap into the equity built up in the
              property for major expenses like home improvements, education, or
              debt consolidation.
              <br />
              Refinancing can be a good financial move, but it often involves
              closing costs and fees, so it's essential to weigh the benefits
              against the costs.
            </span>
            <Link to="/refinancing" className="refinanceContentBoxButton">
              More details
            </Link>
          </div>
          <span className="refinanceSpanImage">
            <img
              fetchPriority="high"
              loading="eager"
              src={officeWorkLaptop}
              alt="officeWorkLaptop"
            />
          </span>
        </div>
      </div>
      <div className="reHistoricalBoxParent">
        <div className="reHistoricalBox">
          <span className="reHistoricalHeading">
            Refinance at Historically Low Rates!
          </span>
          <div className="reHistoricalContentBoxParent">
            <div className="reHistoricalContentBox">
              <span className="reHistoricalContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={loseIcon}
                  alt="loseIcon"
                />
              </span>
              <span className="reHistoricalContentBoxHeading">
                Lower Monthly Payment
              </span>
              <span className="reHistoricalContentBoxContent">
                Take advantage of today’s exceptionally low rates to reduce your
                payment, bringing peace of mind during uncertain times.
              </span>
              <b>Ideal For</b>
              <span className="reHistoricalContentBoxBottomParent">
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={coinHand}
                      alt="coinHand"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Extra Monthly Funds
                  </span>
                </span>
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={piggyBank}
                      alt="piggyBank"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Building Your Retirement Savings!
                  </span>
                </span>
              </span>
              {/* <span className='reHistoricalContentBoxButton'>Reduce My Payment</span> */}
            </div>
            <div className="reHistoricalContentBox">
              <span className="reHistoricalContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={houseMoney}
                  alt="houseMoney"
                />
              </span>
              <span className="reHistoricalContentBoxHeading">
                Get Cash Out
              </span>
              <span className="reHistoricalContentBoxContent">
                If your home’s value has gone up, tap into that equity for cash,
                available for any purpose!
              </span>
              <b>Perfect For</b>
              <span className="reHistoricalContentBoxBottomParent">
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={rollerStick}
                      alt="rollerStick"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Home Renovations
                  </span>
                </span>
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={CreditCard}
                      alt="CreditCard"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Paying Off Expensive Debt
                  </span>
                </span>
              </span>
              {/* <span className='reHistoricalContentBoxButton'>Use My Equity</span> */}
            </div>
            <div className="reHistoricalContentBox">
              <span className="reHistoricalContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={time2}
                  alt="time2"
                />
              </span>
              <span className="reHistoricalContentBoxHeading">
                Shorten Your Loan Term
              </span>
              <span className="reHistoricalContentBoxContent">
                With lower rates on 15-year mortgages, your payment might stay
                similar while you pay off the loan faster!
              </span>
              <b>Ideal For</b>
              <span className="reHistoricalContentBoxBottomParent">
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={payMoney}
                      alt="payMoney"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Saving on Interest
                  </span>
                </span>
                <span className="reHistoricalContentBoxBottom">
                  <span className="reHistoricalContentBoxBottomSpanImage">
                    <img
                      fetchPriority="high"
                      loading="eager"
                      src={thumbsUp}
                      alt="thumbsUp"
                    />
                  </span>
                  <span className="reHistoricalContentBoxBottomText">
                    Paying Off Your Home Sooner!
                  </span>
                </span>
              </span>
              {/* <span className='reHistoricalContentBoxButton'>Shorten My Team</span> */}
            </div>
          </div>
        </div>
      </div>
      <div className="purchasingBoxParent purchasingBoxParent00">
        <div className="purchasingBox">
          <span className="purchasingHeading">
            Submit Your Application Today
          </span>
          <span className="purchasingContent">
            Use our user-friendly online application to get started.
          </span>
          <Link to="/purchase" className="purchasingButton">
            More details
          </Link>
        </div>
      </div>
      <div className="latestNewsBoxParent">
        <div className="latestNewsBox">
          <span className="latestNewsSpanImage">
            <img fetchPriority="high" loading="eager" src={news} alt="news" />
          </span>
          <div className="latestNewContentBox">
            <span className="latestNewHeading">Latest Headlines</span>
            <span className="latestNewContent01">
              Eurozone bond investors are placing greater emphasis on addressing
              public finances.
            </span>
            <span className="latestNewContent02">
              According to Societe Generale, eurozone government bond investors
              have turned their attention to public finances, noting that the
              negative outlooks issued by Moody’s for Belgium and Fitch for
              France served as a wake-up call.
            </span>
          </div>
        </div>
      </div>
      <div className="purchasingBoxParent purchasingBoxParent01">
        <div className="purchasingBox purchasingBox01">
          <ul>
            <span className="purchasingHeading purchasingHeading01">
              Learning Portal
            </span>
            <li>Loan application steps</li>
            <li>What’s my financial limit?</li>
            <li>Refinancing breakdown</li>
            <li>Monthly payment calculation</li>
            <li>Clarification of mortgage conditions</li>
          </ul>
          <div></div>
        </div>
      </div>
      <HomePageMonthlyPayment />
    </div>
  );
}

export default Home;
